import axios from 'axios';

// import router from '@/router';
import auth from '@/utils/auth';

import {
  EXPORT_REPORTS,
  EXPORT_REPORTS_ERROR,
  EXPORT_REPORTS_SUCCESS,

  DOWNLOAD_INCOME_STATEMENT_REPORT,
  DOWNLOAD_INCOME_STATEMENT_REPORT_ERROR,
  DOWNLOAD_INCOME_STATEMENT_REPORT_SUCCESS,

  DOWNLOAD_GL_REPORT,
  DOWNLOAD_GL_REPORT_ERROR,
  DOWNLOAD_GL_REPORT_SUCCESS,

  DOWNLOAD_BALANCE_SHEET_REPORT,
  DOWNLOAD_BALANCE_SHEET_REPORT_ERROR,
  DOWNLOAD_BALANCE_SHEET_REPORT_SUCCESS,

  GET_GL,
  GET_GL_ERROR,
  GET_GL_SUCCESS,

  GET_BALANCE_SHEET,
  GET_BALANCE_SHEET_ERROR,
  GET_BALANCE_SHEET_SUCCESS,

  GET_SOI,
  GET_SOI_ERROR,
  GET_SOI_SUCCESS,

  GET_DRD,
  GET_DRD_ERROR,
  GET_DRD_SUCCESS,

  DRD_DOWNLOAD,
  DRD_DOWNLOAD_ERROR,
  DRD_DOWNLOAD_SUCCESS,

  DRD_DOWNLOAD_PDF,
  DRD_DOWNLOAD_PDF_ERROR,
  DRD_DOWNLOAD_PDF_SUCCESS,

  DRD_EXPORT_PDF,
  DRD_EXPORT_PDF_ERROR,
  DRD_EXPORT_PDF_SUCCESS,

  EXPORT_COOWNER_SECTION,
  EXPORT_COOWNER_SECTION_ERROR,
  EXPORT_COOWNER_SECTION_SUCCESS,

} from './constants';

export default {
  async [EXPORT_REPORTS]({ commit }, args) {
    try {
      commit(EXPORT_REPORTS);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/export`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: {
          syndicateID: args.syndicateID,
          startDate: args.startDate,
          endDate: args.endDate,
          reports: args.reports,
        },
      });
      commit(EXPORT_REPORTS_SUCCESS, response.data);
    } catch (err) {
      commit(EXPORT_REPORTS_ERROR, err);
    }
  },

  async [EXPORT_COOWNER_SECTION]({ commit }, args) {
    try {
      commit(EXPORT_COOWNER_SECTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowners/reports/export`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: {
          syndicateID: args.syndicateID,
          startDate: args.startDate,
          endDate: args.endDate,
          sections: args.sections,
        },
      });
      commit(EXPORT_COOWNER_SECTION_SUCCESS, response.data);
    } catch (err) {
      commit(EXPORT_COOWNER_SECTION_ERROR, err);
    }
  },

  async [GET_GL]({ commit }, args) {
    try {
      commit(GET_GL);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/general-ledger`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          date1: args.startDate,
          date2: args.endDate,
        },
      });
      commit(GET_GL_SUCCESS, response.data);
    } catch (err) {
      commit(GET_GL_ERROR, err);
    }
  },

  async [GET_BALANCE_SHEET]({ commit }, args) {
    try {
      commit(GET_BALANCE_SHEET);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/balance-sheet`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          date1: args.date1,
          date2: args.date2,
        },
      });
      commit(GET_BALANCE_SHEET_SUCCESS, response.data);
    } catch (err) {
      commit(GET_BALANCE_SHEET_ERROR, err);
    }
  },

  async [GET_SOI]({ commit }, args) {
    try {
      commit(GET_SOI);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/income-statement`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          fiscalYear: args.fiscalYear,
        },
      });
      commit(GET_SOI_SUCCESS, response.data);
    } catch (err) {
      commit(GET_SOI_ERROR, err);
    }
  },

  async [DOWNLOAD_INCOME_STATEMENT_REPORT]({ commit }, args) {
    try {
      commit(DOWNLOAD_INCOME_STATEMENT_REPORT);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/income-statement/download`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          fiscalYear: args.fiscalYear,
        },
      });
      commit(DOWNLOAD_INCOME_STATEMENT_REPORT_SUCCESS, response.data);
    } catch (err) {
      commit(DOWNLOAD_INCOME_STATEMENT_REPORT_ERROR, err);
    }
  },

  async [DOWNLOAD_BALANCE_SHEET_REPORT]({ commit }, args) {
    try {
      commit(DOWNLOAD_BALANCE_SHEET_REPORT);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/balance-sheet/download`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          date1: args.date1,
          date2: args.date2,
        },
      });
      commit(DOWNLOAD_BALANCE_SHEET_REPORT_SUCCESS, response.data);
    } catch (err) {
      commit(DOWNLOAD_BALANCE_SHEET_REPORT_ERROR, err);
    }
  },

  async [DOWNLOAD_GL_REPORT]({ commit }, args) {
    try {
      commit(DOWNLOAD_GL_REPORT);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/general-ledger/download`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          date1: args.startDate,
          date2: args.endDate,
        },
      });
      commit(DOWNLOAD_GL_REPORT_SUCCESS, response.data);
    } catch (err) {
      commit(DOWNLOAD_GL_REPORT_ERROR, err);
    }
  },

  async [GET_DRD]({ commit }, args) {
    try {
      commit(GET_DRD);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/drd`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          year: args.year,
        },
      });
      commit(GET_DRD_SUCCESS, response.data);
    } catch (err) {
      commit(GET_DRD_ERROR, err);
    }
  },

  async [DRD_DOWNLOAD]({ commit }, args) {
    try {
      commit(DRD_DOWNLOAD);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/drd/download`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: {
          syndicateID: args.syndicateID,
          drd: args.drd,
        },
      });
      commit(DRD_DOWNLOAD_SUCCESS, response.data);
    } catch (err) {
      commit(DRD_DOWNLOAD_ERROR, err);
    }
  },

  async [DRD_DOWNLOAD_PDF]({ commit }, args) {
    try {
      commit(DRD_DOWNLOAD_PDF);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/drd/download-pdf`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: {
          syndicateID: args.syndicateID,
          drd: args.drd,
        },
      });
      commit(DRD_DOWNLOAD_PDF_SUCCESS, response.data);
    } catch (err) {
      commit(DRD_DOWNLOAD_PDF_ERROR, err);
    }
  },
  async [DRD_EXPORT_PDF]({ commit }, args) {
    try {
      commit(DRD_EXPORT_PDF);
      const response = await axios({
        url: `${process.env.API_URL}/api/reports/drd/download-transaction-pdf`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: {
          syndicateID: args.syndicateID,
          drd: args.drd,
        },
      });
      commit(DRD_EXPORT_PDF_SUCCESS, response.data);
    } catch (err) {
      commit(DRD_EXPORT_PDF_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/actions.js